import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';
import config from 'devextreme/core/config';
import { licenseKey } from './app/devextreme-license';
import { AppModule } from './app/app.module';

if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .catch((err) => console.error(err));

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));

//I provider che c'era qui sono stati messi nell'AppModule a causa dell'autenticazione con Entra ID che può essere usata solo con NgModule

// bootstrapApplication(AppComponent, {
//   providers: [
//     provideRouter(routes),
//     provideHttpClient(withInterceptors([SecurityHeaderInterceptor])),
//     AuthService,
//     ScreenService,
//     AppInfoService,
//   ],
// });

config({
  licenseKey,
});
